module.exports = __webpack_public_path__ + "img/jcb-square.84cba870.svg";